import { render, staticRenderFns } from "./ListMultipleAssignments.vue?vue&type=template&id=3bfb4c44"
import script from "./ListMultipleAssignments.js?vue&type=script&lang=js&external"
export * from "./ListMultipleAssignments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports